// import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './components/Home';
import About from './components/About';
import Contact from './components/Contact';
import Navigation from './components/Navigation';
import Whoweare from "./components/Whoweare";
import Approach from "./components/Approach";
import Weserve from './components/Weserve';
// import {BrowserRouter, Switch, Route } from 'react-router-dom';
// import {BrowserRouter, Switch,  Route,  } from 'react-router-dom';
import Web from './Web/Web';
import Seo from './DigitalMarketing/Seo';
import ProductVideo from './Videos/ProductVideo';
import AnimatedVideo from './Videos/AnimatedVideo';
import Website from './Ourwork/Website';
import Education from './Industries/Education';
import './Utility/style.css'
import Industries from './Industries/Industries';
function App() {
  return (
    <>    
  
   
   
  

<BrowserRouter>  
<Navigation />           
        <Routes>
          <Route exact path="/" element={<Home />} />
           
          <Route exact path="/"  >  
            <Route exact path="/about" element={<About />} />  
            <Route exact path="/whoweare" element={<Whoweare />} />         
            <Route exact path="/approach" element={<Approach />} />         
            <Route exact path="/weserve" element={<Weserve />} /> 
          </Route>
          <Route exact path="/web" element={<Web />} />         
          <Route exact path="/seo" element={<Seo />} />  
          <Route exact path="/"  > 
              <Route exact path="/AnimatedVideo" element={<AnimatedVideo />} />   
              <Route exact path="/productvideo" element={<ProductVideo />} />   
          </Route>   
          <Route exact path="/" >
            <Route exact path="/website" element={<Website />} />
          </Route>
          <Route exact path="/" >
          <Route exact path="/education" element={<Education />} />  
          <Route exact path="/indusries" element={<Industries />} />  
          </Route>

          <Route exact path="/contact" element={<Contact/> } />
        </Routes>
      </BrowserRouter>
    </>
  );
}

<Home />
export default App;
